import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useItemCurationPriority } from '@/hooks/item';
import { ItemCurationPriorityModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemCurationPriorityModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const itemR = useItem(item.productId, false);
  const { mutate, isLoading, isSuccess, isError, error } = useItemCurationPriority(item.productId);

  const getErrorMessage = (): string => {
    try {
      const raw = error?.response?.data?.message;
      if (!raw) return t('service_error.general');
      const parsed = JSON.parse(raw);
      return parsed.detail || parsed.message || t('service_error.general');
    } catch {
      return t('service_error.general');
    }
  };

  if (isError) {
    return (
      <ErrorModal
        title={t('modal.item_curation_priority.title')}
        message={getErrorMessage()}
        onClose={onClose}
      />
    );
  } else if (isSuccess) {
    return (
      <SuccessModal
        title={t('modal.item_curation_priority.title')}
        onClose={onClose}
      />
    );
  }

  const body = isLoading ? (
    <LoadingBodyModal height={40} />
  ) : (
    <div className={clsx([styles.text1rem, styles.paddingY1rem])}>
      {t('modal.item_curation_priority.body')}
    </div>
  );

  return (
    <StandardModal
      title={t('modal.item_curation_priority.title')}
      onClose={onClose}
      onSubmit={() => mutate(undefined, { onSuccess: () => itemR.refetch() })}
      submitLabel={t('common.submit').toUpperCase()}
      submittable={!isLoading}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_curation_priority"
    />
  );
};

export default View;
